/**
 * @generated SignedSource<<8717c2cc029c3ba89c7c421f114ba27c>>
 * @relayHash b7c110fee25ad08a800acb8d1785010d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0ed34092e73d412113398461f3063acc590ca71d26453733d46198e528d3d8e1

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type browseSkillsUnifiedPaginationQuery$variables = {
  after?: string | null;
  cloudId: string;
  first?: number | null;
  searchKeyword?: string | null;
};
export type browseSkillsUnifiedPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef">;
};
export type browseSkillsUnifiedPaginationQuery = {
  response: browseSkillsUnifiedPaginationQuery$data;
  variables: browseSkillsUnifiedPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": 30,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchKeyword"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "searchKeyword",
    "variableName": "searchKeyword"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v4 = {
  "kind": "ScalarField",
  "name": "iconUrl"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "browseSkillsUnifiedPaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "browseSkills_AtlassianRovoSkills_BrowseSkillsUnified_preloadedRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "browseSkillsUnifiedPaginationQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "ConvoAiAvailableSkillsResult",
        "kind": "LinkedField",
        "name": "convoai_availableSkills",
        "plural": false,
        "selections": [
          {
            "concreteType": "ConvoAiSkillEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "ConvoAiSkill",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  (v2/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "name"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "description"
                  },
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "slashCommand"
                  },
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "iconKey"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "color"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "helpText"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "source"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "tags"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "integrationKeys"
                  },
                  {
                    "concreteType": "ConvoAiSkillIntegration",
                    "kind": "LinkedField",
                    "name": "integrations",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/)
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "name": "version"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "hasPreviousPage"
              },
              {
                "kind": "ScalarField",
                "name": "startCursor"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "totalCount"
          },
          {
            "concreteType": "ConvoAiSkillListMetadata",
            "kind": "LinkedField",
            "name": "metadata",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "anthropicCount"
              },
              {
                "kind": "ScalarField",
                "name": "stratusCount"
              },
              {
                "kind": "ScalarField",
                "name": "isDegraded"
              }
            ]
          },
          {
            "concreteType": "QueryError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          }
        ]
      },
      {
        "args": (v1/*: any*/),
        "filters": [
          "cloudId",
          "searchKeyword"
        ],
        "handle": "connection",
        "key": "browseSkills__convoai_availableSkills",
        "kind": "LinkedHandle",
        "name": "convoai_availableSkills"
      }
    ]
  },
  "params": {
    "id": "0ed34092e73d412113398461f3063acc590ca71d26453733d46198e528d3d8e1",
    "metadata": {},
    "name": "browseSkillsUnifiedPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "6c35cc4125ef7d7282e5c0de48a97f2e";

export default node;
